// app/javascript/components/FallbackMessageBody.jsx

import React, {useEffect, useState} from "react";
import {formatTime} from "../utils/formatTime";
import {getRequestObject, renderAuthenticatedFileLinks, renderRequestElements, styles} from "../utils/messageUtils";
import useBrowserLanguage, {languageMap} from "../utils/useBrowserLanguage";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGlobe} from "@fortawesome/free-solid-svg-icons";
import {useMediaQuery} from "./hooks";
import ReactMarkdown from "react-markdown";

export default function FallbackMessageBody(props) {
    const {message, userId, conversationId} = props;
    const displayName = message?.user?.nickname || message?.user?.user_id || "User";
    const isByMe = userId === message?.user?.user_id || false;
    const messageType = message.type;
    const browserLanguage = useBrowserLanguage();
    const rawText = typeof message.message === 'string' ? message.message : String(message.message ?? '');
    const [requestObject, setRequestObject] = useState(null);
    const requestId = message.data;
    const [translations, setTranslations] = useState(message.translations || null);
    const [displayText, setDisplayText] = useState(rawText);
    const isMobile = useMediaQuery('(max-width: 768px)');

    useEffect(() => {
        if (message.custom_type && requestId) {
            getRequestObject(message.custom_type, requestId).then((response) => {
                setRequestObject(response);
            });
        }
    }, [message.custom_type, requestId]);

    useEffect(() => {
        const t = translations;
        if (t && Object.entries(t).length > 0 && t[browserLanguage]) {
            setDisplayText(t[browserLanguage]);
        } else {
            setDisplayText(rawText);
        }
    }, [translations, browserLanguage, rawText])

    const requestElements = renderRequestElements(requestObject, message.sorted_metaarray?.[0], message.custom_type, requestId);

    async function handleTranslate() {
        try {
            const result = await $.ajax({
                url: `/conversations/${conversationId}/translate_message`,
                method: 'POST',
                dataType: 'json',
                data: {
                    message_id: message.message_id,
                    target_language: browserLanguage,
                },
            });
            setTranslations(result.translations);
        } catch (err) {
            window.sentry?.captureException(err);
        }
    }

    return (
        <div>
            {messageType === 'ADMM' && (
                <div className="sendbird-limited-service-feed-system-message">
                    <ReactMarkdown>
                        {displayText}
                    </ReactMarkdown>
                </div>
            )}
            {messageType === 'MESG' && (
                <div className={`sendbird-limited-service-feed-list-item ${isByMe ? "outgoing" : "incoming"}`}>
                    <span style={{fontSize: 0.75 + 'rem', fontWeight: 'bold'}}>
                        {displayName}
                    </span>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-start',
                        position: 'relative',
                        overflow: 'visible'
                    }}>
                        <div
                            className={`sendbird-limited-service-feed-user-message ${isByMe ? "outgoing" : "incoming"}`}>
                            <ReactMarkdown>
                                {displayText}
                            </ReactMarkdown>
                            <div style={styles.actionsContainer(isMobile)}>
                                {requestElements}
                            </div>
                        </div>
                        <button
                            className="sendbird-limited-service-translate-button"
                            onClick={handleTranslate}
                            aria-label="Translate message"
                        >
                            <FontAwesomeIcon style={{marginRight: '0.25rem'}} icon={faGlobe}/>
                            <p>Translate to {languageMap[browserLanguage] || browserLanguage}</p>
                        </button>
                    </div>
                    <span style={{fontSize: 0.75 + 'rem'}}>
                        {formatTime(message.created_at)}
                    </span>
                </div>

            )}
            {messageType === 'FILE' && (
                <div className={`sendbird-limited-service-feed-list-item ${isByMe ? "outgoing" : "incoming"}`}>
                    <span style={{fontSize: 0.75 + 'rem', fontWeight: 'bold'}}>
                        {displayName}
                    </span>
                    <div className={`sendbird-limited-service-feed-user-message ${isByMe ? "outgoing" : "incoming"}`}>
                        {renderAuthenticatedFileLinks(message.file, conversationId)}
                    </div>
                    <span style={{fontSize: 0.75 + 'rem'}}>
                        {formatTime(message.created_at)}
                    </span>
                </div>
            )}
        </div>
    );
}
